// language=GraphQL
export const ALL_COLLECTIVE_DISCOUNTS_QUERY = `query Query($withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
  collectiveDiscounts: ratioCollectiveDiscounts {
    id
    label
    info
    ageGroupServices @include(if: $withAgeGroupServices) {
      id
      ageGroup @include(if: $withAgeGroupServicesAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      ratioServiceNo
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
      }
      useDateSwitch
      dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
        id
        startDateOffsetDays
        endDateOffsetDays
      }
      useBusSettings
      busSettings @include(if: $withMandatorySettingsBusSettings) {
        id
        boardingSelectionEnabled
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_COLLECTIVE_DISCOUNT_QUERY = `query Query($id: ID!, $withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
  collectiveDiscount: ratioCollectiveDiscount(id: $id) {
    id
    label
    info
    ageGroupServices @include(if: $withAgeGroupServices) {
      id
      ageGroup @include(if: $withAgeGroupServicesAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      ratioServiceNo
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
      }
      useDateSwitch
      dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
        id
        startDateOffsetDays
        endDateOffsetDays
      }
      useBusSettings
      busSettings @include(if: $withMandatorySettingsBusSettings) {
        id
        boardingSelectionEnabled
      }
    }
  }
}`

// language=GraphQL
export const CREATE_COLLECTIVE_DISCOUNT_MUTATION = `
  mutation Mutation($input: CreateRatioCollectiveDiscountInput, $withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
    collectiveDiscount: createRatioCollectiveDiscount(input: $input) {
      id
      label
      info
      ageGroupServices @include(if: $withAgeGroupServices) {
        id
        ageGroup @include(if: $withAgeGroupServicesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        ratioServiceNo
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_COLLECTIVE_DISCOUNT_MUTATION = `
  mutation Mutation($input: UpdateRatioCollectiveDiscountInput, $withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
    collectiveDiscount: updateRatioCollectiveDiscount(input: $input) {
      id
      label
      info
      ageGroupServices @include(if: $withAgeGroupServices) {
        id
        ageGroup @include(if: $withAgeGroupServicesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        ratioServiceNo
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_COLLECTIVE_DISCOUNT_MUTATION = `
  mutation Mutation($input: DeleteRatioCollectiveDiscountInput) {
    deleteRatioCollectiveDiscount(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_COLLECTIVE_DISCOUNT_MUTATION = `
  mutation Mutation($input: DeleteRatioCollectiveDiscountInput) {
    forceDeleteRatioCollectiveDiscount(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_COLLECTIVE_DISCOUNT_AGE_GROUP_SERVICES_MUTATION = `
  mutation Mutation($input: addRatioCollectiveDiscountAgeGroupServicesInput) {
    addRatioCollectiveDiscountAgeGroupServices(input: $input) {
      id
      ageGroupServiceIds
    }
  }`

// language=GraphQL
export const REMOVE_COLLECTIVE_DISCOUNT_AGE_GROUP_SERVICES_MUTATION = `
  mutation Mutation($input: removeRatioCollectiveDiscountAgeGroupServicesInput) {
    removeRatioCollectiveDiscountAgeGroupServices(input: $input) {
      id
      ageGroupServiceIds
    }
  }`

// language=GraphQL
export const CREATE_COLLECTIVE_DISCOUNT_AGE_GROUP_SERVICES_MUTATION = `
  mutation Mutation($input: createRatioCollectiveDiscountAgeGroupServicesInput) {
    createRatioCollectiveDiscountAgeGroupServices(input: $input) {
      id
      ageGroupServiceIds
    }
  }`

// language=GraphQL
export const DELETE_COLLECTIVE_DISCOUNT_AGE_GROUP_SERVICES_MUTATION = `
  mutation Mutation($input: deleteRatioCollectiveDiscountAgeGroupServicesInput) {
    deleteRatioCollectiveDiscountAgeGroupServices(input: $input) {
      id
      ageGroupServiceIds
    }
  }`

// language=GraphQL
export const UPDATE_COLLECTIVE_DISCOUNT_AGE_GROUP_SERVICES_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioCollectiveDiscountAgeGroupServicesOrderInput) {
    updateRatioCollectiveDiscountAgeGroupServicesOrder(input: $input) {
      id
      ageGroupServiceIds
    }
  }`

// language=GraphQL
export const COLLECTIVE_DISCOUNTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravels: Boolean = false) {
  groupedDependents: ratioCollectiveDiscountDependents(id: $id) {
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus
      suppressBusBoardingSelection    }
  }
}`
